import { formatDistanceToNow, format } from 'date-fns';
import { ja } from 'date-fns/locale';

/**
 * 相対時間を取得（例: 3分前、2時間前）
 */
export const getRelativeTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return formatDistanceToNow(date, {
      addSuffix: true,
      locale: ja,
    });
  } catch (error) {
    console.error('Error formatting relative time:', error);
    return dateString;
  }
};

/**
 * 日付をフォーマット（例: 2024年1月27日）
 */
export const formatDate = (dateString: string, formatStr: string = 'yyyy年M月d日'): string => {
  try {
    const date = new Date(dateString);
    return format(date, formatStr, { locale: ja });
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

/**
 * 日時をフォーマット（例: 2024年1月27日 14:30）
 */
export const formatDateTime = (dateString: string): string => {
  return formatDate(dateString, 'yyyy年M月d日 HH:mm');
};

/**
 * 時刻のみをフォーマット（例: 14:30）
 */
export const formatTime = (dateString: string): string => {
  return formatDate(dateString, 'HH:mm');
};
